var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("productController", [
    "$scope",
    "$rootScope",
    "$window",
    "$location",
    "$q",
    "$document",
    "$filter",
    "$timeout",
    "urlService",
    "productService",
    "elasticService",
    "modalService",
    "loaderService",
    "storefrontApp.mainContext",
    "$sce",
    "commonService",
    "validationService",
    "randomService",
    "cartService",
    "membershipService",
    "favoritesService",
    function (
        $scope,
        $rootscope,
        $window,
        $location,
        $q,
        $document,
        $filter,
        $timeout,
        urlService,
        productService,
        elasticService,
        modalService,
        loaderService,
        storefrontAppMainContext,
        $sanitize,
        commonService,
        validationService,
        randomService,
        cartService,
        membershipService,
        favoritesService
    ) {
        // #region variables
        $scope.colors = [];
        $scope.inspirations = [];
        $scope.selectedVariantId = 1;
        $scope.inspirationsMaster = [];
        $scope.showBottomContent = false;
        $scope.inspiartionsActiveIndex = 4;
        $scope.tabContent = [];
        $scope.threadsUsed = [];
        $scope.threadsPool = [];
        $scope.threadInfo = [];
        $scope.samples = [];
        $scope.threadsUsed = [];
        $scope.avgRating = null;
        $scope.threadsAvailable = [];
        $scope.threadUsedProductDetails = [];
        $scope.windowWidth = $window.innerWidth;
        $scope.customer = null;
        $scope.hasStock = true;
        $scope.validEmail = true;
        $scope.hasAvailableSize = false;
        $rootscope.isProductInFavorites = false;
        $scope.isCrossStitch = false;
        $scope.islicensed = false;
        $scope.isApplique = false;
        $scope.hasMostPurchasedProduct = false;
        $scope.isBoughttogetherSaleActive = false;
        $scope.excludeShowFreeConversionTo = [
            "pdfpattern",
            "embrilliance",
            "elp",
            "pulse",
            "wilcom",
        ];
        var referProductDefault = {
            toEmailId: "",
            fromEmailId: "",
            message: "",
            copyMe: false,
            itemId: "",
        };
        $scope.brandSampleItems = [];
        $scope.isfreeShippable = false;
        $scope.free_shiptext = "";
        $scope.relatedSales = [];
        $scope.patchTimeout;
        $scope.faq_activeIndex = 0;
        $scope.selectedPatchQuantity = "1";
        $scope.activeTab = "showBrands";
        $scope.isDropdownOpen = [];
        $scope.selectedVariant = []; // Initialize selected variant
        $scope.availableVariantOptions = []; // Initialize selected variant
        $scope.showMultipleVariantsDropdowns = false;
        $scope.variantsColorImgBaseUrl = window.__env.variantsColorImgBaseUrl;
        $scope.enableResizeFeature =
            window.__env && window.__env.enableResizeFeature;
        $scope.productsPool = [];
        $scope.productSummary = [];
        $scope.totallistPrice = 0;
        $scope.totalsalePrice = 0;
        $scope.totalclubPrice = 0;

        //#endregion

        // #region Patches
        $scope.getPatchActiveCarousalLength = function (from) {
            if ($scope.windowWidth > 991) {
                return 5;
            } else if ($scope.windowWidth < 575) {
                return 3;
            } else {
                return 4;
            }
        };

        $scope.getActivePatches = function () {
            if (
                angular.isDefined($scope.patchSamplesMaster) &&
                $scope.patchSamplesMaster.length > 0
            ) {
                $scope.activePatchIndex =
                    $scope.getPatchActiveCarousalLength() - 1;
                $scope.patchSamples = $scope.patchSamplesMaster.slice(
                    0,
                    $scope.getPatchActiveCarousalLength()
                );
            }
        };

        $scope.onPatchNavClick = function (navOption) {
            switch (navOption) {
                case "prev":
                    if (
                        $scope.activePatchIndex -
                            $scope.getPatchActiveCarousalLength() +
                            1 >
                        0
                    ) {
                        $scope.activePatchIndex = $scope.activePatchIndex - 1;
                        $scope.patchSamples.pop();
                        $scope.patchSamples.unshift(
                            $scope.patchSamplesMaster[
                                $scope.activePatchIndex -
                                    $scope.getPatchActiveCarousalLength() +
                                    1
                            ]
                        );
                    }
                    break;
                default:
                    if (
                        $scope.activePatchIndex <
                        $scope.patchSamplesMaster.length - 1
                    ) {
                        $scope.activePatchIndex = $scope.activePatchIndex + 1;
                        $scope.patchSamples.splice(0, 1);
                        $scope.patchSamples.push(
                            $scope.patchSamplesMaster[$scope.activePatchIndex]
                        );
                    }
                    break;
            }
        };

        $scope.getPatchContent = function () {
            $rootscope.isPatchEligible = true;
            productService.getPatchContent().then(function (response) {
                if (response) {
                    $scope.questions = response.data.FAQ;
                    $scope.patchSamplesMaster = response.data.Samples;
                    $scope.patchBackings = response.data.Backing;
                    $scope.patchBackgrounds = response.data.Background;
                    $scope.patchBorders = response.data.Border;
                    $scope.patchQuantityLimit = response.data.QuantityThreshold;
                    if ($scope.patchBorders && $scope.patchBorders.length > 0) {
                        $scope.activeBorder = $scope.patchBorders[0];
                    }
                    if (
                        $scope.patchBackings &&
                        $scope.patchBackings.length > 0
                    ) {
                        $scope.selectedBacking = $scope.patchBackings[0].name;
                    }
                    if (
                        $scope.patchBackgrounds &&
                        $scope.patchBackgrounds.length > 0
                    ) {
                        $scope.selectedBackground = $scope.patchBackgrounds[0];
                    }
                    $scope.getActivePatches();
                }
            });
        };

        $scope.toggleAnswer = function (index) {
            $scope.faq_activeIndex =
                $scope.faq_activeIndex === index ? -1 : index;
        };

        $scope.onPatchBorderClick = function (selectedBorder) {
            $scope.activeBorder = selectedBorder;
        };

        checkIsPatchAvailable = function () {
            if (
                $scope.activeProductVariant &&
                $scope.activeProductVariant.isPatchEligible
            ) {
                $scope.showPatch = true;
                var patchURL = urlService.getProductUrl({
                    definitionName: "patch",
                    catalogId: $scope.productInfo._source.catalog,
                    name: $scope.productInfo._source.name,
                    sku: $scope.prdId + "_var_" + $scope.selectedVariantId,
                });
                if (window.innerWidth < 992) {
                    $rootscope.patchURL = patchURL;
                } else {
                    $timeout(function () {
                        $rootscope.patchURL = patchURL;
                    }, 3000);
                }
            } else {
                $scope.showPatch = false;
                $scope.patchURL = undefined;
            }
        };

        $scope.onClickClosePatch = function () {
            $scope.showPatch = false;
        };

        $scope.onBackingChange = function (selectedBacking) {
            if (selectedBacking) {
                var backing = $scope.patchBackings.filter(function (patch) {
                    return (
                        patch.name.toLowerCase() ===
                        selectedBacking.toLowerCase()
                    );
                });

                if (backing.length > 0) {
                    $scope.patchPrice =
                        $scope.patchPriceMaster + backing[0].PriceGradient;
                } else {
                    $scope.patchPrice = $scope.patchPriceMaster;
                }
            } else {
                $scope.patchPrice = $scope.patchPriceMaster;
            }
        };

        $scope.setPatchPrice = function (price) {
            $scope.patchPriceMaster = price;
            $scope.patchPrice = $scope.patchPriceMaster;
        };

        $scope.onSelectedBackgroundChange = function (background) {
            $scope.selectedBackground = background;
        };

        $scope.addPatchToCart = function (variant) {
            loaderService.show();
            var patchLineItem = {
                Border: $scope.activeBorder.name.replace(" ", "-"),
                Backing: $scope.selectedBacking,
                BackgroundColor: $scope.selectedBackground,
                DesignItemId: $scope.productId[0],
                DesignVariantId: variant ? variant : $scope.selectedVariantId,
                Quantity: Number($scope.selectedPatchQuantity),
                DesignCatalog: $scope.catalog,
            };
            cartService
                .addEmbroideryPatchToCart(patchLineItem)
                .then(function (response) {
                    if (response && response.data && response.data.itemAdded) {
                        $rootscope.$broadcast("CustomerCartChanged");
                        window.location.href = "/cart";
                    } else {
                        loaderService.hide();
                        alert("Failed to add product to cart.");
                    }
                });
        };

        $scope.getDesignUrl = function () {
            return urlService.getProductUrl({
                sku: $scope.prdId,
                definitionName: $scope.prdDefinition,
                name: $scope.productInfo._source.name,
                catalogId: $scope.productInfo._source.catalog,
            });
        };
        // #endregion

        $scope.onNavClick = function (navOption) {
            switch (navOption) {
                case "prev":
                    if (
                        $scope.windowWidth > 1599 &&
                        $scope.inspiartionsActiveIndex - 5 > 0
                    ) {
                        $scope.inspiartionsActiveIndex =
                            $scope.inspiartionsActiveIndex - 1;
                        $scope.inspirations.pop();
                        $scope.inspirations.unshift(
                            $scope.inspirationsMaster[
                                $scope.inspiartionsActiveIndex - 5
                            ]
                        );
                    } else if (
                        $scope.windowWidth < 1600 &&
                        $scope.inspiartionsActiveIndex - 4 > 0
                    ) {
                        $scope.inspiartionsActiveIndex =
                            $scope.inspiartionsActiveIndex - 1;
                        $scope.inspirations.pop();
                        $scope.inspirations.unshift(
                            $scope.inspirationsMaster[
                                $scope.inspiartionsActiveIndex - 4
                            ]
                        );
                    }
                    break;
                default:
                    if (
                        $scope.inspiartionsActiveIndex <
                        $scope.inspirationsMaster.length
                    ) {
                        $scope.inspiartionsActiveIndex =
                            $scope.inspiartionsActiveIndex + 1;
                        $scope.inspirations.splice(0, 1);
                        $scope.inspirations.push(
                            $scope.inspirationsMaster[
                                $scope.inspiartionsActiveIndex - 1
                            ]
                        );
                    }
                    break;
            }
        };

        //#region Common
        $scope.$watch(
            function () {
                return storefrontAppMainContext.customer;
            },
            function () {
                if (storefrontAppMainContext.customer) {
                    $scope.customer = storefrontAppMainContext.customer;
                    getcustomerFTAPreferences();
                }
            }
        );
        //#endregion

        //#region Inspirations
        function checkInspirations() {
            $q.all([
                productService.getInspirationImages(
                    $scope.prdId,
                    $scope.prdDefinition,
                    $scope.prdCatalog
                ),
                productService.checkProductVideosExists(
                    $scope.prdId,
                    $scope.prdCatalog
                ),
            ]).then(function (responses) {
                if (responses && responses.length > 0) {
                    var inspirations = responses[0].data;
                    var checkVideoExists = responses[1].data;
                    var video = undefined;
                    if (
                        checkVideoExists &&
                        angular.isDefined(window.__env) &&
                        angular.isDefined(window.__env.productVideosBaseUrl)
                    ) {
                        var prd = getElm("prd");
                        var videoTag = document.createElement("video");
                        videoTag.id = "prdMainVideo";
                        videoTag.style.display = "none";
                        videoTag.controls = true;
                        videoTag.autoplay = true;
                        prd.appendChild(videoTag);
                        var videoUrl = urlService.getProductVideoUrl({
                            catalogId: $scope.catalog,
                            sku: $scope.prdId.split(/-(.+)/)[1],
                        });
                        video = {
                            id: 1,
                            videoUrl: videoUrl,
                        };
                    }

                    $scope.inspirationsMaster.push($rootscope.currentProduct);
                    angular.forEach(inspirations, function (img, key) {
                        var imageUrl = urlService.getImageUrl({
                            definitionName: $scope.prdDefinition,
                            size: "xlarge",
                            catalogId: $scope.catalog,
                            sku: $scope.prdId.split(/-(.+)/)[1],
                        });
                        imageUrl = imageUrl.replace(
                            /.webp|.jpg|.gif/gi,
                            function () {
                                return "/" + img;
                            }
                        );
                        $scope.inspirationsMaster.push({
                            id:
                                key + 1 >= 1 && angular.isDefined(video)
                                    ? key + 2
                                    : key + 1,
                            imgUrl: imageUrl,
                        });
                    });

                    if (angular.isDefined(video)) {
                        $scope.inspirationsMaster.splice(1, 0, video);
                    }
                    $scope.getActiveInspirations();
                }
            });
        }

        $scope.getActiveInspirations = function () {
            if (
                angular.isDefined($scope.inspirationsMaster) &&
                $scope.inspirationsMaster.length > 0
            ) {
                if ($scope.windowWidth > 1599) {
                    $scope.inspiartionsActiveIndex = 5;
                    $scope.inspirations = angular
                        .copy($scope.inspirationsMaster)
                        .splice(0, 5);
                } else {
                    $scope.inspiartionsActiveIndex = 4;
                    $scope.inspirations = angular
                        .copy($scope.inspirationsMaster)
                        .splice(0, 4);
                }
            }
        };

        $scope.onInspirationImageClick = function (image) {
            $rootscope.currentProduct = image;
            $scope.setImgSrc("prdMainImg", "prdMainVideo", image);
        };
        //#endregion

        // #region Tab Content
        $scope.onTabClick = function (activeTab, tabContent, activeSmTab) {
            if (
                activeTab.toLowerCase() == "showreviews" &&
                angular.isUndefined($scope.reviews)
            ) {
                getFiniteReviews($scope.productId);
            }
            if (angular.isDefined(activeSmTab) && activeSmTab.length > 0) {
                if ($window.innerWidth > 767) {
                    $scope.activeTab = activeTab;
                } else $scope.activeTab = activeSmTab;
            } else {
                if (angular.isDefined(tabContent) && tabContent.length > 1)
                    $scope.activeTab = tabContent[0].tabName;
                else $scope.activeTab = activeTab;
            }
        };

        function getAssociatedPacks(productId) {
            elasticService
                .getElasticData(
                    elasticService.buildAssociatedPacksRequest(
                        productId.toString().toUpperCase()
                    )
                )
                .then(function (response) {
                    if (response && "hits" in response.data) {
                        var associatedPacks = response.data.hits.hits;
                        associatedPacks.forEach(function (f) {
                            if (
                                f &&
                                f._source &&
                                f._source.variants &&
                                f._source.variants.length > 0
                            ) {
                                f._source.desc =
                                    f._source.variants[0].numberOfDesigns +
                                    " Designs in 1 Pack";
                            }
                        });
                        $scope.associatedPacksMaster =
                            angular.copy(associatedPacks);
                        $scope.getActiveRelatedItems();
                    }
                });
        }

        function getProductRelatedProjects(productId) {
            productService
                .getProductRelatedProjects(productId)
                .then(function (response) {
                    if (response && response.data && response.data.length > 0) {
                        $scope.associatedProjects = response.data;
                    }
                })
                .catch(function (error) {
                    console.error(error);
                });
        }
        //#endregion

        //#region Misc Functions
        $scope.toggleModal = function (key, state) {
            if (state) {
                modalService.open(key);
            } else {
                modalService.close(key);
            }
        };

        $scope.openResizeModal = function () {
            $scope.toggleModal("personalized-designs", true);
            return;
        };

        $scope.onReviewImgClick = function (imgUrl) {
            $scope.currentReviewImgUrl = imgUrl;
            $scope.toggleModal("reviewImgLargeView", true);
        };

        $scope.selectVariantId = function (id) {
            $scope.selectedVariantId = id;
        };

        $scope.getActiveCarousalLength = function () {
            if ($scope.windowWidth > 1200) {
                return 6;
            } else if ($scope.windowWidth > 991 && $scope.windowWidth < 1200) {
                return 4;
            } else if ($scope.windowWidth > 767 && $scope.windowWidth < 992) {
                return 3;
            } else if ($scope.windowWidth < 767) {
                return 2;
            } else {
                return 2;
            }
        };

        $scope.getActiveLargeCarousalLength = function () {
            if ($scope.windowWidth > 1200) {
                return 4;
            } else if ($scope.windowWidth > 991 && $scope.windowWidth < 1200) {
                return 3;
            } else if ($scope.windowWidth < 992) {
                return 2;
            } else {
                return 2;
            }
        };

        $scope.getActiveSamples = function () {
            if ($scope.getActiveCarousalLength() != $scope.samples.length) {
                $scope.activeIndex = $scope.getActiveCarousalLength() - 1;
                $scope.samples = $scope.threadUsedProductDetails.slice(
                    0,
                    $scope.getActiveCarousalLength()
                );
            }
        };

        $scope.getActiveRelatedItems = function () {
            if (
                (angular.isUndefined($scope.associatedPacks) ||
                    $scope.getActiveLargeCarousalLength() !=
                        $scope.associatedPacks.length) &&
                angular.isDefined($scope.associatedPacksMaster)
            ) {
                $scope.activeIndex_lg =
                    $scope.getActiveLargeCarousalLength() - 1;
                $scope.associatedPacks = $scope.associatedPacksMaster.slice(
                    0,
                    $scope.getActiveLargeCarousalLength()
                );
            }
        };

        $scope.getThreadConverterUrl = function () {
            if (
                $scope.prdBrand &&
                $scope.prdId &&
                $scope.threadMfg &&
                $scope.threadType
            ) {
                return (
                    "/threads/threadconverter?catalog=" +
                    $scope.prdBrand.replace(/ /g, "_") +
                    "&productid=" +
                    $scope.prdId +
                    "&threadmfg=" +
                    $scope.threadMfg +
                    "&threadtype=" +
                    $scope.threadType
                ).toLowerCase();
            } else {
                return "/threadconversionchart";
            }
        };

        $scope.onThreadNavClick = function (navOption) {
            switch (navOption) {
                case "prev":
                    if (
                        $scope.activeIndex -
                            $scope.getActiveCarousalLength() +
                            1 >
                        0
                    ) {
                        $scope.activeIndex = $scope.activeIndex - 1;
                        $scope.samples.pop();
                        $scope.samples.unshift(
                            $scope.threadUsedProductDetails[
                                $scope.activeIndex -
                                    $scope.getActiveCarousalLength() +
                                    1
                            ]
                        );
                    }
                    break;
                default:
                    if (
                        $scope.activeIndex <
                        $scope.threadUsedProductDetails.length - 1
                    ) {
                        $scope.activeIndex = $scope.activeIndex + 1;
                        $scope.samples.splice(0, 1);
                        $scope.samples.push(
                            $scope.threadUsedProductDetails[$scope.activeIndex]
                        );
                    }
                    break;
            }
        };

        $scope.onRelatedItemsNavClick = function (navOption) {
            switch (navOption) {
                case "prev":
                    if (
                        $scope.activeIndex_lg -
                            $scope.getActiveLargeCarousalLength() +
                            1 >
                        0
                    ) {
                        $scope.activeIndex_lg = $scope.activeIndex_lg - 1;
                        $scope.associatedPacks.pop();
                        $scope.associatedPacks.unshift(
                            $scope.associatedPacksMaster[
                                $scope.activeIndex_lg -
                                    $scope.getActiveLargeCarousalLength() +
                                    1
                            ]
                        );
                    }
                    break;
                default:
                    if (
                        $scope.activeIndex_lg <
                        $scope.associatedPacksMaster.length - 1
                    ) {
                        $scope.activeIndex_lg = $scope.activeIndex_lg + 1;
                        $scope.associatedPacks.splice(0, 1);
                        $scope.associatedPacks.push(
                            $scope.associatedPacksMaster[$scope.activeIndex_lg]
                        );
                    }
                    break;
            }
        };
        //#endregion

        // #region Image Large View & Zoom Functionality
        $scope.onImageChange = function (selectedKey) {
            var id = 0;
            switch (selectedKey) {
                case "prev":
                    if ($rootscope.currentProduct.id > 0) {
                        id = $rootscope.currentProduct.id - 1;
                    }
                    break;
                default:
                    if (
                        $rootscope.currentProduct.id <=
                            $scope.inspirationsMaster.length &&
                        $rootscope.currentProduct.id >= 0
                    ) {
                        id = $rootscope.currentProduct.id + 1;
                    }
                    break;
            }
            $rootscope.currentProduct = {
                id: id,
                imgUrl: $scope.inspirationsMaster[id].imgUrl,
                videoUrl: $scope.inspirationsMaster[id].videoUrl,
            };
            $scope.setImgSrc(
                "prdLgImg",
                "prdLgVideo",
                $rootscope.currentProduct
            );
            $scope.setImgSrc(
                "prdMainImg",
                "prdMainVideo",
                $rootscope.currentProduct
            );
        };

        $scope.showLargerView = function () {
            var prdLg = getElm("prdLg");
            var videoprdLg = document.createElement("video");
            videoprdLg.id = "prdLgVideo";
            videoprdLg.style.display = "none";
            videoprdLg.controls = true;
            videoprdLg.autoplay = true;
            videoprdLg.setAttribute("aria-hidden", "true");
            prdLg.appendChild(videoprdLg);
            $scope.toggleModal("imgLargeView", true);
            $scope.setImgSrc(
                "prdLgImg",
                "prdLgVideo",
                $rootscope.currentProduct
            );
        };

        function isValDefined(val) {
            return angular.isDefined(val);
        }

        function getElm(key) {
            return document.getElementById(key);
        }

        $scope.setImgSrc = function (imgSrcId, vdoSrcId, currentActivePrd) {
            var imgElm = getElm(imgSrcId);
            var vdoElm = getElm(vdoSrcId);
            if (
                isValDefined(imgElm) &&
                imgElm != null &&
                isValDefined(currentActivePrd)
            ) {
                if (
                    isValDefined(currentActivePrd.imgUrl) &&
                    currentActivePrd.imgUrl != null
                ) {
                    imgElm.src = currentActivePrd.imgUrl;
                    imgElm.style.display = "block";

                    if (isValDefined(vdoElm) && vdoElm != null)
                        vdoElm.style.display = "none";
                }
                if (
                    isValDefined(vdoElm) &&
                    vdoElm != null &&
                    angular.isDefined(currentActivePrd.videoUrl) &&
                    currentActivePrd.videoUrl != null
                ) {
                    vdoElm.src = currentActivePrd.videoUrl;
                    vdoElm.style.display = "block";
                    imgElm.style.display = "none";
                }
            }
        };
        // #endregion

        //#region Copyright Content
        $scope.getProductCopyright = function (productId) {
            if (angular.isUndefined($scope.productCopyright)) {
                var productIds = [];
                productIds.push(productId);
                $scope.productCopyright = null;
                productService
                    .getCopyrightsByProductIds(productIds)
                    .then(function (response) {
                        if (
                            response &&
                            response.data &&
                            response.data.length > 0
                        ) {
                            $scope.productCopyright = {
                                copyrightsText_Html:
                                    response.data[0].copyrightsText_Html,
                            };
                        }
                    });
            }
        };
        function imageZoom(imgID, resultID) {
            var img, lens, result, cx, cy;

            img = $document[0].getElementById(imgID);
            result = $document[0].getElementById(resultID);

            var lens = $document[0].getElementById("img-zoom-lens");
            if (lens) {
                lens.parentElement.removeChild(lens);
            }

            lens = document.createElement("DIV");
            lens.setAttribute("class", "img-zoom-lens");
            lens.setAttribute("id", "img-zoom-lens");
            img.parentElement.insertBefore(lens, img);

            /*calculate the ratio between result DIV and lens:*/
            cx = result.offsetWidth / lens.offsetWidth;
            cy = result.offsetHeight / lens.offsetHeight;

            result.style.left = "-30000px";
            result.style.backgroundImage = "url('" + img.src + "')";
            img.addEventListener("load", function () {
                result.style.backgroundImage = "url('" + img.src + "')";
                result.style.backgroundSize =
                    img.width * cx + "px " + img.height * cy + "px";
            });

            /*execute a function when someone moves the cursor over the image, or the lens:*/
            lens.addEventListener("mousemove", moveLens);
            img.addEventListener("mousemove", moveLens);

            lens.addEventListener("mouseleave", hideLens);
            img.addEventListener("mouseleave", hideLens);

            /*and also for touch screens:*/
            lens.addEventListener("touchmove", moveLens, { passive: true });
            img.addEventListener("touchmove", moveLens, { passive: true });

            function hideLens(e) {
                result.style.left = "-30000px";
            }

            function moveLens(e) {
                var pos, x, y;
                e.preventDefault();
                pos = getCursorPos(e);

                result.style.left = "100%";
                /*calculate the position of the lens:*/
                x = pos.x - lens.offsetWidth / 2;
                y = pos.y - lens.offsetHeight / 2;

                /*prevent the lens from being positioned outside the image:*/
                if (x > img.width - lens.offsetWidth) {
                    x = img.width - lens.offsetWidth;
                }
                if (x < 0) {
                    x = 0;
                }
                if (y > img.height - lens.offsetHeight) {
                    y = img.height - lens.offsetHeight;
                }
                if (y < 0) {
                    y = 0;
                }

                /*set the position of the lens:*/
                lens.style.left = x + "px";
                lens.style.top = y + "px";
                result.style.backgroundSize =
                    img.width * (cx * 0.75) +
                    "px " +
                    img.height * (cy * 0.75) +
                    "px";
                result.style.backgroundPosition =
                    "-" + x * (cx * 0.75) + "px -" + y * (cy * 0.75) + "px";
            }

            function getCursorPos(e) {
                var a,
                    x = 0,
                    y = 0;
                e = e || window.event;
                a = img.getBoundingClientRect();
                x = e.pageX - a.left;
                y = e.pageY - a.top;
                x = x - window.pageXOffset;
                y = y - window.pageYOffset;
                return { x: x, y: y };
            }
        }
        //#endregion

        //#region Color Charts
        $scope.getThreadMfgByCatalog = function () {
            if ($scope.colors.length < 1) {
                var colorSequence = $scope.productInfo._source.colorSequence;
                productService
                    .getThreadMfgByCatalog($scope.productInfo._source.catalog)
                    .then(function (response) {
                        if (response) {
                            if (response.data) {
                                $scope.threadMfg = response.data.threadMfg;
                                $scope.threadType = response.data.threadType;
                            }
                            if (
                                $scope.productInfo._source.licensed &&
                                $scope.productInfo._source.catalog.toLowerCase() ==
                                    "great notions"
                            ) {
                                $scope.threadMfg = "Madeira";
                            }

                            getThreadConverterColorChart(colorSequence);
                        }
                    });
            }
        };

        function getColorCode(sequence) {
            if (sequence.indexOf("(") !== -1 && sequence.indexOf(")") !== -1) {
                return sequence.substring(
                    sequence.indexOf("(") + 1,
                    sequence.indexOf(")")
                );
            } else {
                return sequence.substring(sequence.indexOf(".") + 1).trim();
            }
        }

        function getThreadConverterColorChart(colorSequence) {
            var seqNo = "";
            var seqTitle = "";
            var colorCodeArray = [];
            var colorSequenceArray = [];
            colorSequence = colorSequence.replace(/&|#/g, "");
            if (colorSequence.indexOf("~^~^") != -1) {
                colorSequenceArray = colorSequence.split("~^~^");
            } else {
                colorSequenceArray = colorSequence.split("~^");
            }
            angular.forEach(colorSequenceArray, function (seq) {
                colorCodeArray.push(getColorCode(seq));
            });
            if ($scope.threadMfg != null) {
                productService
                    .getThreadConverterColorChart(
                        colorCodeArray.toString(),
                        $scope.threadMfg,
                        "true"
                    )
                    .then(function (response) {
                        if (response && response.data) {
                            $scope.threadConverterSequence = response.data;
                            angular.forEach(colorSequenceArray, function (seq) {
                                var hex,
                                    colorCode,
                                    colorName,
                                    itemId = "";
                                var threadChart = [];
                                colorCode = getColorCode(seq);
                                threadChart =
                                    $scope.threadConverterSequence.filter(
                                        function (s) {
                                            return s.colorCode == colorCode;
                                        }
                                    );

                                if (colorCode.trim().toLowerCase() == "black") {
                                    hex = "000";
                                } else if (
                                    colorCode.trim().toLowerCase() == "white"
                                ) {
                                    hex = "fff";
                                } else if (
                                    angular.isDefined(threadChart) &&
                                    threadChart.length > 0
                                ) {
                                    hex = threadChart[0].hex;
                                    colorName = threadChart[0].colorName;
                                    itemId = threadChart[0].itemId;
                                }
                                if (seq.indexOf(".") < 1) {
                                    seqNo = "";
                                    seqTitle = seq;
                                } else {
                                    seqNo = seq.split(".")[0];
                                    seqTitle = seq.substring(
                                        seq.indexOf(".") + 1
                                    );
                                }
                                var threadUrl = urlService.getProductUrl({
                                    definitionName: "threads",
                                    catalogId: $scope.threadMfg,
                                    name:
                                        $scope.threadMfg +
                                        " " +
                                        $scope.threadType +
                                        " " +
                                        colorName,
                                    sku: itemId,
                                });
                                $scope.colors.push({
                                    seqNo: seqNo,
                                    title: seqTitle,
                                    threadUrl: threadUrl,
                                    bgCode:
                                        angular.isDefined(hex) && hex !== ""
                                            ? "#" + hex
                                            : "",
                                });
                            });

                            angular.forEach(
                                $scope.threadConverterSequence,
                                function (value, key) {
                                    var exists = false;
                                    angular.forEach(
                                        $scope.threadsPool,
                                        function (val2, key) {
                                            if (
                                                angular.equals(
                                                    value.threadLength,
                                                    val2.threadLength
                                                )
                                            ) {
                                                exists = true;
                                            }
                                        }
                                    );
                                    if (
                                        exists == false &&
                                        value.threadLength != ""
                                    ) {
                                        $scope.threadsPool.push({
                                            threadLength: value.threadLength,
                                            threadMfg: value.threadMfg,
                                        });
                                    }
                                }
                            );
                            if ($scope.threadsPool.length > 0) {
                                getThreadsYard();
                            }
                        }
                    });
            } else {
                angular.forEach(colorSequenceArray, function (title) {
                    if (title.indexOf(".") < 0) {
                        seqNo = "";
                        seqTitle = title;
                    } else {
                        seqNo = title.substr(0, title.indexOf(".")).trim();
                        seqTitle = title.substr(title.indexOf(".") + 1).trim();
                    }
                    $scope.colors.push({
                        seqNo: seqNo,
                        bgCode: "",
                        threadUrl: "",
                        title: seqTitle,
                    });
                });
            }
        }

        function getThreadsYard() {
            $scope.yards = $scope.threadsPool[0].threadLength;
            $scope.threadsUsed = $scope.threadConverterSequence.filter(
                function (s) {
                    return s.threadLength == $scope.yards;
                }
            );
            $scope.getThreadProductInfo();
        }

        $scope.getThreadsUsed = function (yards) {
            $scope.threadsUsed.length = 0;
            $scope.threadsUsed = [];
            $scope.threadUsedProductDetails = [];
            $scope.samples = [];
            threadsUsedIndex = 0;
            $scope.threadsUsed = $scope.threadConverterSequence.filter(
                function (s) {
                    return s.threadLength == yards;
                }
            );
            $scope.getThreadProductInfo();
        };

        $scope.getThreadProductInfo = function () {
            var elmIds = $scope.threadsUsed.map(function (thread) {
                return thread.itemId.indexOf("_var_") > 1
                    ? thread.itemId.split("_var_")[0]
                    : thread.itemId;
            });

            elasticService
                .getElasticData(
                    elasticService.buildProductInfoRequest(
                        elmIds,
                        undefined,
                        undefined,
                        true
                    )
                )
                .then(function (response) {
                    if (response) {
                        for (var i = 0; i < $scope.threadsUsed.length; i++) {
                            var item = $scope.threadsUsed[i];
                            var itemId = item.itemId;
                            var elmVar =
                                itemId.indexOf("_var_") > 1
                                    ? itemId.split("_var_")[1]
                                    : 1;

                            var filteredProduct =
                                response.data.hits.hits.filter(function (res) {
                                    return (
                                        res._id ==
                                        itemId.split("_var_")[0].toLowerCase()
                                    );
                                });

                            if (filteredProduct.length === 0) {
                                continue;
                            }

                            var filteredVariants =
                                filteredProduct[0]._source.variants.filter(
                                    function (res) {
                                        return res.variantId == elmVar;
                                    }
                                );

                            var variant = filteredVariants[0] || {};
                            var definitionName =
                                response.data.hits.hits[0]._source
                                    .definitionName;

                            $scope.threadUsedProductDetails.push({
                                salePrice: variant.salePrice,
                                clubPrice: variant.clubPrice,
                                listPrice: variant.listPrice,
                                colorCode: item.colorCode,
                                itemId: item.itemId.toLowerCase(),
                                colorName: item.colorName,
                                hex: "#" + item.hex,
                                threadMfg: item.threadMfg,
                                threadType: item.threadType.split(" ")[0],
                                definitionName: definitionName,
                                threadConeImageName: item.threadConeImageName,
                                catalogName: item.catalogName,
                                showBtn: variant.listPrice > 0,
                            });
                        }

                        $scope.samples = $scope.threadUsedProductDetails.slice(
                            0,
                            $scope.getActiveCarousalLength()
                        );
                        $scope.activeIndex =
                            $scope.getActiveCarousalLength() - 1;
                        $scope.getActiveSamples();
                    }
                });
        };

        //#endregion

        // #region color chart print functionality
        $scope.onPrdColorSeqPrint = function () {
            $window.print();
        };
        //#endregion

        //#region Product Related Functions
        function compare(a, b) {
            var orderA = a.tabOrder;
            var orderB = b.tabOrder;

            var comparison = 0;
            if (orderA > orderB) {
                comparison = 1;
            } else if (orderA < orderB) {
                comparison = -1;
            }
            return comparison;
        }
        //#endregion

        function getTabContent(productId) {
            if (angular.isDefined(productId)) {
                elasticService
                    .getElasticData(
                        elasticService.buildVariantTabContentRequest(
                            productId,
                            $scope.selectedVariantId
                        )
                    )
                    .then(function (response) {
                        var currentVariant =
                            response.data.hits.hits[0].fields.filtered_variants;
                        if (
                            angular.isDefined(currentVariant) &&
                            currentVariant.length > 0 &&
                            currentVariant[0].productTabContent
                        ) {
                            var splitContent =
                                currentVariant[0].productTabContent
                                    .replace(/.aspx/g, "")
                                    .split('href="javascript:newin')
                                    .join(
                                        'class="cust-popup" onclick="onPopupClick'
                                    )
                                    .split("*|*");
                            for (var i = 0; i < splitContent.length; i += 3) {
                                var content = {
                                    tabOrder: splitContent[i],
                                    tabName: splitContent[i + 1],
                                    tabContent: splitContent[i + 2],
                                };
                                $scope.tabContent.push(content);
                            }
                            $scope.tabContent = $scope.tabContent.sort(compare);
                        }
                    });
            } else {
                $scope.tabContent = [];
            }
        }

        function checkColorChartAvailable() {
            var fileSubpath =
                $scope.catalog + "\\" + $scope.prdVariant.split("-")[1];
            productService
                .isColorChartAvailable(fileSubpath, "ColorChart")
                .then(function (response) {
                    if (response) {
                        $scope.isColorChartAvailable = response.data;
                    }
                });
        }

        $scope.onVariantChange = function (variantId) {
            // Handle custom size request
            if (
                variantId &&
                (variantId === "custom-size" ||
                    variantId.startsWith("custom-size-"))
            ) {
                $scope.toggleModal("personalized-designs", true);
                return;
            }

            // Handle normal variant changes
            loaderService.show();
            $window.location.replace(
                "/" +
                    urlService.getProductUrl({
                        definitionName: $scope.prdDefinition,
                        catalogId: $scope.productInfo._source.catalog,
                        name: $scope.productInfo._source.name,
                        sku: $scope.prdId + "_var_" + variantId,
                    })
            );

            loaderService.hide();
        };
        $scope.onPatchVariantChange = function (variantId) {
            loaderService.show();
            $window.location.replace(
                "/" +
                    urlService.getProductUrl({
                        definitionName: "patch",
                        catalogId: $scope.productInfo._source.catalog,
                        name: $scope.productInfo._source.name,
                        sku: $scope.prdId + "_var_" + variantId,
                    })
            );

            loaderService.hide();
        };

        function getCurrentProductInfo(productId, variantId) {
            elasticService
                .getElasticData(
                    elasticService.buildProductInfoRequest(productId, [
                        "variants.productTabContent",
                        "mainFeatures",
                    ])
                )
                .then(function (response) {
                    if (response && response.data) {
                        loaderService.hide();
                        $scope.productInfo = response.data.hits.hits[0];
                        $scope.prdId = $scope.productInfo._source.itemId;
                        $scope.prdBrand = $scope.productInfo._source.brand;
                        $scope.prdCatalog = $scope.productInfo._source.catalog;
                        $scope.descriptioninfo =
                            $scope.productInfo._source.description;
                        if (
                            window.__env.isFrequentlyBoughtTogetherEnabled ==
                            true
                        ) {
                            checkMostpurchasedItemsAvailable(
                                $scope.prdId,
                                $scope.prdCatalog
                            );
                        } else {
                            $scope.hasMostPurchasedProduct = false;
                            $scope.isBoughttogetherSaleActive = false;
                        }

                        if (angular.isDefined($scope.descriptioninfo)) {
                            var arr = $scope.descriptioninfo.split("<tr>");
                            if (arr.length > 5) $scope.hasAvailablesize = true;
                            else $scope.hasAvailablesize = false;
                        }

                        $scope.prdBrandHyphens = $scope.prdBrand.replace(
                            / /g,
                            "-"
                        );
                        $rootscope.efpFont =
                            $scope.productInfo._source.productId.toLowerCase() ==
                            "efp";
                        $scope.prdDefinition =
                            $scope.productInfo._source.definitionName;
                        $scope.catalog =
                            $scope.productInfo._source.catalog.replace(
                                /\s/g,
                                "_"
                            );
                        $scope.brandImage =
                            "/common/images/brandicons/" +
                            $scope.prdBrandHyphens.toLowerCase() +
                            ".png";
                        $scope.mainFeatures =
                            $scope.productInfo._source.mainFeatures;

                        //Active Variant Info
                        $scope.activeProductVariant =
                            $scope.productInfo._source.variants.filter(
                                function (data) {
                                    return (
                                        data.variantId ==
                                        $scope.selectedVariantId
                                    );
                                }
                            );

                        if (
                            angular.isDefined($scope.activeProductVariant) &&
                            $scope.activeProductVariant.length > 0
                        ) {
                            $scope.activeProductVariant =
                                $scope.activeProductVariant[0];
                        }
                        $scope.getBrandCatalog();
                        $rootscope.currentProduct = {
                            id: 0,
                            imgUrl: urlService.getImageUrl({
                                definitionName: $scope.prdDefinition,
                                size: "xlarge",
                                catalogId: $scope.catalog,
                                sku: $scope.prdId,
                            }),
                        };

                        $scope.setImgSrc(
                            "prdMainImg",
                            "prdMainVideo",
                            $rootscope.currentProduct
                        );

                        if (
                            $scope.productInfo &&
                            $scope.productInfo._source.customerInterestIndex
                        ) {
                            var customerInterestIndexThreshold =
                                window.__env.customerInterestIndexThreshold ||
                                5;
                            var customerInterestIndexMaxThreshold =
                                window.__env
                                    .customerInterestIndexMaxThreshold || 25;
                            $scope.cart_count =
                                $scope.productInfo._source.customerInterestIndex;
                            $scope.showInCarts =
                                $scope.cart_count >
                                    customerInterestIndexThreshold &&
                                $scope.cart_count <
                                    customerInterestIndexMaxThreshold;
                            $scope.showInMaxCarts =
                                $scope.cart_count >
                                    customerInterestIndexThreshold &&
                                $scope.cart_count >
                                    customerInterestIndexMaxThreshold;
                        }

                        checkInspirations();
                        if (!angular.isUndefined($scope.prdId)) {
                            if (variantId == 1) {
                                $scope.prdVariant = $scope.prdId;
                            } else {
                                $scope.prdVariant =
                                    $scope.prdId + "_var_" + variantId;
                            }
                        }

                        if (
                            $scope.prdDefinition.toLowerCase() == "font" ||
                            $scope.prdDefinition.toLowerCase() ==
                                "stockdesign" ||
                            $scope.prdDefinition.toLowerCase() == "software"
                        ) {
                            if (
                                $location &&
                                $location.$$absUrl &&
                                $location.$$absUrl.length > 0
                            ) {
                                $scope.prdUrl = $location.$$absUrl.substring(
                                    $location.$$absUrl.indexOf(
                                        "/productdetails/"
                                    )
                                );
                            }
                        }
                        if (
                            $scope.prdDefinition.toLowerCase() == "font" ||
                            $scope.prdDefinition.toLowerCase() ==
                                "stockdesign" ||
                            $scope.prdDefinition.toLowerCase() ==
                                "designpack" ||
                            $scope.prdDefinition.toLowerCase() == "fontpack" ||
                            $scope.prdDefinition.toLowerCase() ==
                                "projectpack" ||
                            $scope.prdDefinition.toLowerCase() == "printart" ||
                            $scope.prdDefinition.toLowerCase() == "svg" ||
                            $scope.prdDefinition
                                .toLowerCase()
                                .indexOf("pdf patterns") > -1 ||
                            $scope.prdDefinition.toLowerCase() ==
                                "hand embroidery"
                        ) {
                            getProductRelatedProjects(productId);
                        }
                        if (
                            $scope.prdDefinition.toLowerCase() == "font" ||
                            $scope.prdDefinition.toLowerCase() == "stockdesign"
                        ) {
                            getAssociatedPacks(productId);
                        } else {
                            $scope.getActiveRelatedItems();
                        }
                        if (
                            $scope.prdDefinition.toLowerCase() ==
                                "designpack" ||
                            $scope.prdDefinition.toLowerCase() == "fontpack"
                        ) {
                            $scope.pg = "1";
                            $scope.associatedItemsPerPage = "12";
                            getAssociatedItems();
                        }
                        if (
                            $scope.prdDefinition.toLowerCase() == "stockdesign"
                        ) {
                            checkHasPrintArt();
                            checkHasFSL();
                            checkIsPatchAvailable();
                            $scope.getThreadMfgByCatalog();
                        }
                        if ($scope.prdDefinition.toLowerCase() == "font") {
                            checkColorChartAvailable();
                            checkforFontFormats();
                        }
                        if (
                            $scope.prdDefinition.toLowerCase() == "svg" ||
                            $scope.prdDefinition.toLowerCase() == "printart"
                        ) {
                            checkHasEmbroideryDesign();
                        }
                        if (
                            $scope.prdId
                                .substring(
                                    $scope.prdId.indexOf("-") + 1,
                                    $scope.prdId.indexOf("-") + 3
                                )
                                .toLowerCase() === "lc"
                        ) {
                            checkHasFillStitch();
                        }
                        if (
                            $scope.productInfo._source.productType.toLowerCase() ==
                            "physical"
                        ) {
                            var baseLineQty =
                                window.__env.cartbaseLineQty || 10;
                            productService
                                .hasInventory($scope.prdVariant)
                                .then(function (response) {
                                    $scope.qtyInHand = response.data;
                                    $scope.hasStock = response.data > 0;
                                    $scope.showQty =
                                        response.data < baseLineQty;
                                });

                            var variantsSuffix =
                                window.__env.showOptionsAsVariantsSuffix ||
                                "merchandise";
                            if (
                                variantsSuffix.indexOf(
                                    $scope.prdDefinition.toLowerCase()
                                ) > -1 ||
                                $scope.productInfo._source
                                    .isMultipleVariantsAvailable
                            ) {
                                $scope.showOptionsAsSuffix = true;
                            } else {
                                $scope.showOptionsAsSuffix = false;
                            }

                            productService
                                .isfreeShippable(
                                    $scope.productInfo._source.itemId,
                                    $scope.productInfo._source.catalog
                                )
                                .then(function (res) {
                                    var data = res.data;
                                    if (data) {
                                        $scope.isfreeShippable =
                                            data.isFreeShippable;
                                        var ship_text =
                                            '<tr><td><font color="#CC0066">&nbsp;&#8226;&nbsp;</font></td><td width="100%">Limited-Time <a id="myAnchor" class="f-shiplink" onClick="onFreeShippingBtnClick()">FREE SHIPPING</a> within the US.' +
                                            (data.minOrderValueForFreeShipping >
                                            1
                                                ? '<span style="font-size: 14px;"> (Min. purchase of $' +
                                                  data.minOrderValueForFreeShipping +
                                                  " or more) </span>"
                                                : "") +
                                            "</td></tr>";
                                        $scope.free_shiptext =
                                            $scope.isfreeShippable
                                                ? ship_text
                                                : "";
                                    }
                                });
                        }
                        if (
                            $scope.prdDefinition.toLowerCase() == "projectpack"
                        ) {
                            if (
                                !angular.isUndefined(
                                    $scope.productInfo._source.colorSequence
                                )
                            )
                                $scope.getThreadMfgByCatalog();
                        }

                        setTimeout(function () {
                            getTabContent($scope.prdId);
                        }, 3000);

                        getcustomerFTAPreferences();

                        document
                            .getElementById("prdMainImg")
                            .addEventListener("load", function () {
                                var elm =
                                    document.getElementById("zoom-result");
                                if (angular.isDefined(elm)) {
                                    elm.style.display = "block";
                                    elm.style.left = "100%";
                                }
                                imageZoom("prdMainImg", "zoom-result");
                            });

                        angular.element($window).bind("resize", function () {
                            imageZoom("prdMainImg", "zoom-result");
                            $scope.$digest();
                        });

                        $scope.isCrossStitch =
                            $scope.productInfo._source.isCrossStitch;
                        $scope.islicensed = $scope.productInfo._source.licensed;
                        $scope.isApplique =
                            $scope.productInfo._source.isApplique;

                        if (
                            angular.isDefined($scope.isCrossStitch) &&
                            $scope.isCrossStitch == true
                        )
                            $scope.DesignType = "Cross Stitch ";
                        else if (
                            angular.isDefined($scope.islicensed) &&
                            $scope.islicensed == true
                        )
                            $scope.DesignType = "Licensed ";
                        else if (
                            angular.isDefined($scope.isApplique) &&
                            $scope.isApplique == true
                        )
                            $scope.DesignType = "Applique ";
                        $scope.getsaleitemKeyFeatures();
                        if (
                            $scope.activeProductVariant &&
                            $scope.activeProductVariant.fTA &&
                            $scope.activeProductVariant.fTA.length > 0
                        ) {
                            $scope.activeProductVariant.fTA.forEach(function (
                                format
                            ) {
                                if (format.toLowerCase() == "pdfpattern") {
                                    $scope.isPDFPattern = true;
                                }
                                if (
                                    window.__env.excludeShowFreeConversionTo &&
                                    window.__env.excludeShowFreeConversionTo
                                        .length > 0
                                ) {
                                    $scope.excludeShowFreeConversionTo =
                                        window.__env.excludeShowFreeConversionTo;
                                }
                                if (
                                    !$scope.excludeShowFreeConversionTo.includes(
                                        format.toLowerCase()
                                    )
                                ) {
                                    $scope.isShowFreeConversion = true;
                                }
                            });
                        }

                        $scope.copyrightText = "";
                        if ($scope.islicensed) {
                            $scope.licensedArtist = "";
                            if (
                                $scope.productInfo &&
                                $scope.productInfo._source &&
                                $scope.productInfo._source.artist
                            ) {
                                $scope.licensedArtist =
                                    $scope.productInfo._source.artist;
                            }
                            $scope.copyrightText +=
                                $scope.prdBrand +
                                " is distributing " +
                                $scope.licensedArtist +
                                ' embroidery designs ("the Product") under a license from ';
                            $scope.copyrightText +=
                                $scope.licensedArtist +
                                ", who retains all of the artistic rights (intellectual property rights) in the Product. You cannot copy the artwork, software, or promotional materials. The license, with " +
                                $scope.licensedArtist +
                                ", contains restrictions upon the sale and resale of the Product.";
                            $scope.copyrightText +=
                                "<h3><u>Territory / Sales Restrictions</u></h3>Worldwide<br><h3><u>Usage</u></h3>Licensed Embroidery Designs are licensed to the original customer for personal embroidery use, sharing is strictly prohibited. <strong>These embroidery designs cannot be modified or sewn on items for resale.</strong>";
                            productService
                                .getResellableArtists()
                                .then(function (response) {
                                    if (response && response.data) {
                                        $scope.resellableArtists =
                                            response.data;
                                        if (
                                            $scope.resellableArtists.length >
                                                0 &&
                                            $scope.resellableArtists.indexOf(
                                                $scope.licensedArtist.toLowerCase()
                                            ) > -1
                                        ) {
                                            $scope.copyrightText =
                                                "This design may be sewn on items and sold for profit commercially, with limitation. You must have written consent to mass market items using this design. " +
                                                $scope.prdBrand +
                                                " will not be held liable for any monetary losses or consequential damages as a result of using this design.";
                                        }
                                    }
                                });
                        } else {
                            $scope.getProductCopyright(productId);
                        }

                        if (
                            $scope.prdDefinition.toLowerCase() == "merchandise"
                        ) {
                            if (
                                !angular.isDefined(
                                    $scope.activeProductVariant.salePrice
                                )
                            ) {
                                $scope.activeProductVariant.salePrice = "-1";
                            }
                            $scope.merchandiseImgUrl = {
                                id: 0,
                                imgUrl: urlService.getImageUrl({
                                    definitionName: $scope.prdDefinition,
                                    size: "xlarge",
                                    catalogId: $scope.catalog,
                                    sku: $scope.prdId + "_var_" + variantId,
                                }),
                            };

                            $scope.setImgSrc(
                                "prdMainImg",
                                "prdMainVideo",
                                $scope.merchandiseImgUrl
                            );
                        }

                        /* productService.getActiveCouponSales().then(function(couponResponse){
                                $scope.activeCoupons = couponResponse.data;
                            }) */

                        // Check for resize=true query parameter and open personalized design modal
                        var hasResizeParam =
                            ($location &&
                                $location.search() &&
                                $location.search().resize === "true") ||
                            (window.location.search &&
                                window.location.search.indexOf(
                                    "resize=true"
                                ) !== -1);

                        if (hasResizeParam) {
                            // Use $timeout to ensure DOM is ready and modal service is available
                            $timeout(function () {
                                $scope.openResizeModal();
                            });
                        }
                    }
                });
        }

        function checkHasPrintArt() {
            if ($scope.catalog.toLowerCase() == "dakota_collectibles") {
                var productId = $scope.prdId.toLowerCase().replace("-", "-dn");
            } else {
                var productId = $scope.prdId.toLowerCase().replace("-", "-pg");
            }
            elasticService
                .getElasticData(
                    elasticService.buildProductInfoRequest(productId)
                )
                .then(function (response) {
                    if (
                        response &&
                        response.data &&
                        response.data.hits &&
                        response.data.hits.hits.length > 0
                    ) {
                        var product = response.data.hits.hits[0];
                        $scope.hasVectorArt = true;
                        $scope.vectorArtDesignUrl = urlService.getProductUrl({
                            definitionName: product._source.definitionName,
                            catalogId: product._source.catalog,
                            name: product._source.name,
                            sku: product._source.itemId,
                        });
                    }
                });
        }

        function checkHasFSL() {
            var pId = $scope.prdId.replace(/^[^-]+/, "fsl01");
            var productId = pId.toLowerCase().replace("-", "-lc");
            elasticService
                .getElasticData(
                    elasticService.buildProductInfoRequest(productId)
                )
                .then(function (response) {
                    if (
                        response &&
                        response.data &&
                        response.data.hits &&
                        response.data.hits.hits.length > 0
                    ) {
                        var product = response.data.hits.hits[0];
                        var fslProductName = product._source.name
                            .replace("FSL ", "")
                            .trim();
                        if (
                            fslProductName ==
                            $scope.productInfo._source.name.trim()
                        ) {
                            $scope.hasFSL = true;
                            $scope.fslDesignUrl = urlService.getProductUrl({
                                definitionName: product._source.definitionName,
                                catalogId: product._source.catalog,
                                name: product._source.name,
                                sku: product._source.itemId,
                            });
                        }
                    }
                });
        }

        function checkHasEmbroideryDesign() {
            var catalog = $scope.productInfo._source.catalog.toLowerCase();
            var productId = $scope.productInfo._source.productId
                .toLowerCase()
                .replace(catalog == "dakota collectibles" ? "dn" : "pg", "");

            if (
                angular.isDefined(productId) &&
                productId !== null &&
                productId !== ""
            ) {
                var elasticQuery = elasticService.buildProductByProductCode(
                    productId,
                    catalog
                );

                elasticService
                    .getElasticData(elasticQuery)
                    .then(function (response) {
                        if (
                            response &&
                            response.data &&
                            response.data.hits &&
                            response.data.hits.hits.length > 0
                        ) {
                            var product = response.data.hits.hits[0];
                            $scope.hasEmbroideryDesign = true;
                            $scope.embroideryDesignUrl =
                                urlService.getProductUrl({
                                    definitionName:
                                        product._source.definitionName,
                                    catalogId: product._source.catalog,
                                    name: product._source.name,
                                    sku: product._source.itemId,
                                });
                        }
                    });
            }
        }

        function checkHasFillStitch() {
            if ($scope.catalog.toLowerCase() == "fsl_studio")
                var productId = $scope.productInfo._source.productId
                    .toLowerCase()
                    .replace("lc", "");

            if (
                angular.isDefined(productId) &&
                productId != null &&
                productId != ""
            ) {
                elasticService
                    .getElasticData(
                        elasticService.buildProductByProductCode(productId)
                    )
                    .then(function (response) {
                        if (
                            response &&
                            response.data &&
                            response.data.hits &&
                            response.data.hits.hits.length > 0
                        ) {
                            var product = response.data.hits.hits[0];
                            $scope.hasFillStitch = true;
                            $scope.fillStitchDesignUrl =
                                urlService.getProductUrl({
                                    definitionName:
                                        product._source.definitionName,
                                    catalogId: product._source.catalog,
                                    name: product._source.name,
                                    sku: product._source.itemId,
                                });
                        }
                    });
            }
        }

        //#region Reviews
        function getFiniteReviews(productId) {
            if (
                angular.isDefined(productId) &&
                productId != null &&
                productId != ""
            ) {
                productService
                    .getReviewsByProductId(productId, 5)
                    .then(function (response) {
                        $scope.reviews = response.data;
                    });
            }
        }

        $scope.getAllReviews = function () {
            $scope.areReviewsLoading = true;
            productService
                .getReviewsByProductId($scope.productId, 0)
                .then(function (response) {
                    $scope.reviews = response.data;
                    $scope.areReviewsLoading = false;
                });
        };
        //#endregion

        //#region Free Conversion Modal
        $scope.showFreeConversion = function () {
            $scope.toggleModal("mdlFreeConversion", true);
        };
        //#endregion

        //#region Formats section
        $scope.onFormatsClick = function () {
            $scope.toggleModal("saveMachineModal", true);
        };
        //#endregion

        //#region Lower Price
        $scope.resetLowerPriceForm = function () {
            $scope.lowerprice = {};
            $scope.notification = {};
            $scope.lowerPriceForm.$setPristine();
            $scope.lowerPriceForm.$setUntouched();
        };

        $scope.submitLowerPrice = function (lowerPrice, lowerPriceForm) {
            if (lowerPriceForm.$valid) {
                var product = $scope.productInfo;
                lowerPrice.productId = product._source.itemId;
                lowerPrice.priceMentioned = $filter("currency")(
                    lowerPrice.priceSubmitted
                );
                $scope.formLoading = true;
                if (typeof gtag !== "undefined") {
                    gtag("event", "Product Details", {
                        event_category: "engagement",
                        event_action: "found_lower_price_submit",
                    });
                }
                productService
                    .submitLowerPriceRequest(lowerPrice)
                    .then(function (response) {
                        $scope.formLoading = false;
                        if (response && response.data && response.data.isSent) {
                            $scope.lowerprice = {};
                            $scope.lowerPriceForm.$setPristine();
                            $scope.lowerPriceForm.$setUntouched();
                            $scope.notification = {
                                type: "success",
                                content:
                                    "Thank you for submitting your request. Our customer service personal will review your recent request and will contact you soon.",
                            };
                        } else {
                            $scope.notification = {
                                type: "error",
                                content:
                                    "An Error occured while processing your recent request. Please try again later.",
                            };
                        }
                    });
            } else {
                alert("Please submit valid entries");
            }
        };
        //#endregion

        //#region Associated Items for Packs
        $scope.getNumber = function (num) {
            return new Array(num);
        };

        $scope.changePage = function (requestedPage) {
            if (requestedPage != "prev" && requestedPage != "next") {
                $scope.pg = requestedPage;
            } else if (requestedPage == "prev") {
                $scope.pg = (Number($scope.pg) - 1).toString();
            } else if (requestedPage == "next") {
                $scope.pg = (Number($scope.pg) + 1).toString();
            }
        };

        $scope.onIPPChange = function (ipp) {
            $scope.pg = "1";
            $scope.associatedItemsPerPage = ipp;
            $scope.pages =
                $scope.count % $scope.associatedItemsPerPage > 0
                    ? Math.floor($scope.count / $scope.associatedItemsPerPage) +
                      1
                    : $scope.count / $scope.associatedItemsPerPage;
        };

        function getAssociatedItems() {
            var associatedItemsArray = [];
            if (
                $scope.activeProductVariant &&
                $scope.activeProductVariant.associatedItems
            ) {
                var associatedItems =
                    $scope.activeProductVariant.associatedItems.toLowerCase();
                if (associatedItems.toLowerCase().indexOf("_var_") > 1) {
                    angular.forEach(
                        associatedItems.toLowerCase().split(","),
                        function (item, key) {
                            associatedItemsArray.push(
                                item.split(new RegExp("_var_", "ig"))[0]
                            );
                        }
                    );
                } else {
                    associatedItemsArray = associatedItems
                        .toLowerCase()
                        .split(",");
                }
                elasticService
                    .getElasticData(
                        elasticService.buildAssociatedItemsRequest(
                            associatedItemsArray
                        )
                    )
                    .then(function (response) {
                        if (response && "hits" in response.data) {
                            var allAssociatedItems = associatedItems.split(",");
                            if (angular.isDefined(allAssociatedItems)) {
                                $scope.associatedItemsPool = [];
                                allAssociatedItems.forEach(function (elm) {
                                    var elmId = 0;
                                    var elmVar = 1;
                                    if (elm.indexOf("_var_") > 1) {
                                        elmId = elm.split("_var_")[0];
                                        elmVar = elm.split("_var_")[1];
                                    } else {
                                        elmId = elm;
                                        elmVar = 1;
                                    }
                                    var filteredItem =
                                        response.data.hits.hits.filter(
                                            function (res) {
                                                return (
                                                    res._id.toLowerCase() ==
                                                    elmId.toLowerCase()
                                                );
                                            }
                                        );
                                    if (filteredItem.length > 0) {
                                        filteredItem[0].activeVariant = +elmVar;
                                        filteredItem[0].imgUrl =
                                            urlService.getImageUrl({
                                                definitionName:
                                                    filteredItem[0]._source
                                                        .definitionName,
                                                size: "large",
                                                catalogId:
                                                    filteredItem[0]._source
                                                        .catalog,
                                                sku: filteredItem[0]._id,
                                            });
                                        filteredItem[0].prdUrl =
                                            urlService.getProductUrl({
                                                definitionName:
                                                    filteredItem[0]._source
                                                        .definitionName,
                                                catalogId:
                                                    filteredItem[0]._source
                                                        .catalog,
                                                name: filteredItem[0]._source
                                                    .name,
                                                sku:
                                                    filteredItem[0]._id +
                                                    "_var_" +
                                                    elmVar,
                                            });
                                        $scope.associatedItemsPool.push(
                                            angular.copy(filteredItem[0])
                                        );
                                    }
                                });
                            }
                            $scope.count = $scope.associatedItemsPool.length;
                            $scope.pages =
                                $scope.count % $scope.associatedItemsPerPage > 0
                                    ? Math.floor(
                                          $scope.count /
                                              $scope.associatedItemsPerPage
                                      ) + 1
                                    : $scope.count /
                                      $scope.associatedItemsPerPage;

                            $scope.associatedItems = angular.copy(
                                $scope.associatedItemsPool
                            );
                        }
                    });
            }
        }

        //#endregion

        //#region Initiaize Function
        $scope.initialize = function () {
            loaderService.show();
            var productId = _.map($window.products, function (product) {
                return product.id;
            });
            $scope.productId = productId;
            var variantId = _.map($window.products, function (product) {
                return product.currentVariant;
            })[0];

            if (
                productId &&
                productId.length > 0 &&
                angular.isDefined(productId[0]) &&
                productId[0] != ""
            ) {
                $rootscope.logoutUrl =
                    "account/logout" +
                    "?returnurl=" +
                    $window.location.pathname;
                getCurrentProductInfo(productId, variantId);
                checkItemInFavorites(productId);
                getRelatedSales(productId);
            } else {
                $window.location.href = "/404";
            }

            angular.element($window).bind("resize", function () {
                $scope.windowWidth = $window.innerWidth;
                $scope.getActiveInspirations();
                $scope.getActivePatches();
                $scope.getActiveSamples();
                $scope.getActiveRelatedItems();
                $scope.getActiveInspirations();
            });
        };
        //#endregion

        function getcustomerFTAPreferences() {
            if (
                angular.isDefined($scope.activeProductVariant) &&
                angular.isDefined($scope.activeProductVariant.fTA)
            ) {
                var activeProductVariantFtaFormat =
                    $scope.activeProductVariant.fTA;
                if (
                    $scope.customer &&
                    $scope.customer.contact &&
                    $scope.customer.contact.customerPreferences &&
                    $scope.customer.contact.customerPreferences.length > 0 &&
                    angular.isDefined(
                        $scope.customer.contact.customerPreferences[0]
                            .prefFormat
                    )
                ) {
                    $scope.customerSelectedformats =
                        $scope.customer.contact.customerPreferences[0].prefFormat
                            .toLowerCase()
                            .split(",");
                } else {
                    $scope.customerSelectedformats = [];
                }

                var formatHtml = "";
                if (activeProductVariantFtaFormat != null) {
                    for (
                        var i = 0;
                        i < activeProductVariantFtaFormat.length;
                        i++
                    ) {
                        if (
                            $scope.customerSelectedformats.indexOf(
                                activeProductVariantFtaFormat[i].toLowerCase()
                            ) > -1
                        ) {
                            formatHtml +=
                                "<b><i>" +
                                activeProductVariantFtaFormat[i].toUpperCase() +
                                "</i></b>" +
                                ", ";
                        } else {
                            formatHtml +=
                                "<span>" +
                                activeProductVariantFtaFormat[i].toUpperCase() +
                                ", ";
                            ("</span>");
                        }
                    }
                    $scope.formatPrefferedFTaHtml = formatHtml.slice(
                        0,
                        formatHtml.length - 2
                    );
                } else {
                    $scope.formatPrefferedFTaHtml =
                        $scope.activeProductVariant.fTA;
                }
            }
        }

        $scope.trustAsHtml = function (html) {
            return $sanitize.trustAsHtml(html);
        };

        //#region Shipping Related Functions
        $scope.changeSelectedCountry = function () {
            $scope.countrySelected = "selected";
        };

        $scope.getRates = function (isDomestic) {
            var shippingInformation = {};
            shippingInformation.itemId = $scope.prdId;
            shippingInformation.definitionType = $scope.prdDefinition;
            shippingInformation.vendorCode = $scope.catalog;
            shippingInformation.regionCode = "";
            shippingInformation.ounces = $scope.activeProductVariant.weight;
            shippingInformation.quantity = 1;
            shippingInformation.totalShipmentAmount =
                $scope.activeProductVariant.listPrice;

            if (isDomestic) {
                shippingInformation.countryCode = "US";
                shippingInformation.zipDestination =
                    document.getElementById("zipCode").value;
                shippingInformation.countryName = "United States";
            } else {
                var country = document.getElementById("country").value;
                var countryEntry = $scope.countries.filter(function (e) {
                    return e.name.toLowerCase() == country.toLowerCase();
                });
                shippingInformation.countryCode = countryEntry[0].code2;
                shippingInformation.zipDestination = "";
                shippingInformation.countryName = country;
            }

            loaderService.show();
            productService
                .getShippingEstimate(shippingInformation)
                .then(function (data) {
                    if (data && data.data) {
                        if (isDomestic) {
                            $scope.domesticShippingEstimates = data.data;
                        } else {
                            $scope.internationalShippingEstimates = data.data;
                        }
                    }
                    loaderService.hide();
                });
        };

        $scope.showEstimateSection = function (show, hide) {
            if (angular.isUndefined($scope.countries)) {
                commonService.getCountries().then(function (response) {
                    $scope.countries = response.data || [];
                    if ($scope.countries.length > 0) {
                        var index = undefined;

                        for (var i = 0; i < $scope.countries.length; i++) {
                            if (
                                $scope.countries[i].name.toLowerCase() ==
                                "united states"
                            ) {
                                index = i;
                            }
                        }

                        if (index != undefined) {
                            $scope.countries.splice(index, 1);
                        }
                    }
                });
            }

            document.getElementById(show).classList.remove("hide-section");
            document.getElementById(hide).classList.add("hide-section");
        };

        $scope.showFreeShipping = function () {
            $scope.toggleModal("mdlFreeShipping", true);
        };
        //#endregion

        //#region FTA
        $scope.setScopeFTAVariable = function (key, value) {
            if (angular.isDefined(key) && angular.isDefined(value)) {
                $scope[key] = value;
            }
        };
        //#endregion

        //#region REFER A Product
        $scope.openReferProduct = function () {
            if ($scope.customer && $scope.customer.isRegisteredUser) {
                $scope.referProduct = angular.copy(referProductDefault);
                $scope.referProduct.fromEmailId = $scope.customer.email;
                $scope.referProduct.message =
                    document.getElementById("refermessage").value;
                $scope.toggleModal("referProduct", true);
            } else {
                var returnURL =
                    $window.location.pathname + $window.location.search;
                $scope.outerRedirect(
                    $scope.baseUrl +
                        "account/login?returnurl=" +
                        returnURL.replace("&", "%26")
                );
            }
        };

        $scope.closeReferProduct = function (referproductform) {
            $scope.toggleModal("referProduct");
            resetReferProductModal(referproductform);
        };

        resetReferProductModal = function (referproductform) {
            $scope.referProduct = angular.copy(referProductDefault);
            referproductform.$setPristine();
            referproductform.$setUntouched();
        };
        //#endregion

        //#region Notify Section
        $scope.notifyme = function (prodId, catalogId) {
            $scope.validEmail = true;
            document.getElementById("emailNotify").style.border =
                "1px solid black";
            var email = document.getElementById("emailNotify").value;
            if (validationService.getRegularExpressions().email.test(email)) {
                $scope.queue = {};
                $scope.queue.FK_ItemId = $scope.prdVariant;
                $scope.queue.FK_CatalogId = catalogId;
                $scope.queue.EmailAddress = email;
                $scope.enteredEmail = email;
                modalService.open("confirmNotifyModal");
            } else {
                $scope.validEmail = false;
                document.getElementById("emailNotify").style.border =
                    "1px solid red";
            }
        };

        $scope.submitNotify = function () {
            document.getElementById("emailNotify").style.border =
                "1px solid black";
            var email = document.getElementById("emailNotify").value;
            productService
                .insertNotifyInStock($scope.queue)
                .then(function (response) {
                    $scope.enteredEmail = email;
                    $scope.successNotifyInsert = response.data;
                    modalService.close("confirmNotifyModal");
                });
        };
        //#endregion

        // #region Scroll to
        $scope.onScrollTo = function (key) {
            if (angular.isDefined(key)) {
                var elem = document.getElementById(key);
                if (elem != null) {
                    elem.scrollIntoView({ behavior: "smooth" });
                }
            }
        };
        //#endregion

        //#region Project PDF Download
        $scope.onProjectPdfDownload = function () {
            if (
                $scope.associatedProjects &&
                $scope.associatedProjects.length > 0
            ) {
                loaderService.show();
                productService
                    .getProjectPDFUrl($scope.associatedProjects[0].projectId)
                    .then(function (response) {
                        if (response && response.data) {
                            loaderService.hide();
                            $scope.pdfsrc = response.data;
                            $scope.toggleModal(
                                "viewProjectInstructionsModal",
                                true
                            );
                        }
                    });
            }
        };
        //#endregion

        //#region Font Type Availability
        function checkforFontFormats() {
            if (
                $scope.productInfo._source.fontType.toLowerCase() ==
                "embrilliance fonts"
            ) {
                var productId = $scope.prdId.toLowerCase().replace("-bx", "-");
            } else if (
                $scope.productInfo._source.fontType.toLowerCase() ==
                "home format fonts"
            ) {
                var productId = $scope.prdId.toLowerCase().replace("-", "-bx");
            }
            elasticService
                .getElasticData(
                    elasticService.buildProductInfoRequest(productId)
                )
                .then(function (response) {
                    if (
                        response &&
                        response.data &&
                        response.data.hits &&
                        response.data.hits.hits.length > 0
                    ) {
                        var product = response.data.hits.hits[0];
                        if (
                            $scope.productInfo._source.fontType.toLowerCase() ==
                            "embrilliance fonts"
                        ) {
                            $scope.hasHomeFormatFont = true;
                        } else if (
                            $scope.productInfo._source.fontType.toLowerCase() ==
                            "home format fonts"
                        ) {
                            $scope.hasEmbrillianceFont = true;
                        }
                        $scope.fontDesignUrl = urlService.getProductUrl({
                            definitionName: product._source.definitionName,
                            catalogId: product._source.catalog,
                            name: product._source.name,
                            sku: product._source.itemId,
                        });
                    }
                });
        }
        //#endregion

        // #region Sale Features
        $scope.getsaleitemKeyFeatures = function () {
            $scope.salekeyfeature = [];
            productService
                .getSaleitemkeyfeatures($scope.productId)
                .then(function (response) {
                    $scope.saleInfo = response.data;
                });
        };
        // #endregion

        // #region Related Sales
        function getRelatedSales(productId) {
            productService.getRelatedSales(productId).then(function (response) {
                if (response && response.data && response.data.length > 0) {
                    response.data.forEach(function (sale) {
                        if (sale.saleURL.indexOf("/productdetails/") == -1) {
                            $scope.relatedSales.push(sale);
                        }
                    });
                }
            });
        }
        // #endregion

        // #region Product Youtube Video Link

        // #region View Product Video Download
        $scope.onClickViewVideo = function () {
            var vidsrc = $scope.productInfo._source.videoLinks.split(",");
            $scope.videoLinks = [];
            $scope.vidIndex = 0;
            if (vidsrc && vidsrc.length > 0) {
                vidsrc.forEach(function (link) {
                    if (
                        link &&
                        link.length > 0 &&
                        link.indexOf("youtube.com") > -1
                    ) {
                        var newlink = link.concat("?autoplay=1&enablejsapi=1");
                        $scope.videoLinks.push(
                            $sanitize.trustAsResourceUrl(newlink)
                        );
                    }
                });
            }
            $scope.vidsrc = $scope.videoLinks[$scope.vidIndex];
            $scope.toggleModal("viewProductVideo", true);
        };
        //#endregion

        // #region Video Navigation
        $scope.onVideoChange = function (selectedKey) {
            var id = 0;
            switch (selectedKey) {
                case "prev":
                    if ($scope.vidIndex > 0) {
                        id = $scope.vidIndex - 1;
                    }
                    break;
                default:
                    if (
                        $scope.vidIndex <= $scope.videoLinks.length &&
                        $scope.vidIndex >= 0
                    ) {
                        id = $scope.vidIndex + 1;
                    }
                    break;
            }
            $scope.vidIndex = id;
            $scope.vidsrc = $scope.videoLinks[$scope.vidIndex];
        };
        // #endregion

        // #region Close Modal
        $scope.onVideoModalClose = function () {
            document
                .getElementById("yt-player")
                .contentWindow.postMessage(
                    '{"event":"command","func":"stopVideo","args":""}',
                    "*"
                );
            $scope.vidsrc = null;
            $scope.toggleModal("viewProductVideo", false);
        };
        // #endregion

        // #endregion

        $scope.getBrandCatalog = function () {
            elasticService
                .getElasticData(
                    elasticService.buildMoreItemsFromBrandRequest(
                        $scope.prdBrand.toLowerCase(),
                        $scope.prdDefinition,
                        $scope.productId,
                        $rootscope.isPatchEligible
                    )
                )
                .then(function (response) {
                    if (
                        response &&
                        response.data &&
                        response.data.hits &&
                        response.data.hits.hits &&
                        response.data.hits.hits.length > 0
                    ) {
                        $scope.brandSampleItems =
                            randomService.getRandomItemsfromListArray(
                                response.data.hits.hits,
                                6
                            );
                    }
                });
        };

        $scope.getThreadBrdUrl = function (threadMfg) {
            var url = "/threads/threadcategories";
            if (angular.isDefined(threadMfg)) {
                var threadMfgParts = threadMfg.split(" ");
                if (threadMfgParts.length > 0) {
                    url += "?sale=" + threadMfgParts[0].toLowerCase();
                }
            }
            return url;
        };
        $scope.generateGuid = function () {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c === "x" ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                }
            );
        };

        $scope.addBoughtTogetherItemsToCart = function () {
            var addItemPromises = $scope.productSummary.map(function (item) {
                return $scope.addBundleItemToCart(item);
            });
            Promise.all(addItemPromises).then(function () {
                loaderService.hide();
                $window.location.href = "/cart";
            });
        };
        $scope.addBundleItemToCart = function (item) {
            loaderService.show();
            if (item) {
                return cartService
                    .addMultipleProductsAsLineItems(
                        item.itemId,
                        1,
                        $scope.seriesId
                    )
                    .then(function (response) {
                        if (
                            response &&
                            response.data &&
                            response.data.itemAdded
                        ) {
                            //$scope.resetFilters();
                            $rootscope.$broadcast("CustomerCartChanged");
                        }
                        return response;
                    })
                    .catch(function (error) {
                        loaderService.hide();
                        return Promise.reject(error);
                    });
            } else {
                loaderService.hide();
                return Promise.resolve();
            }
        };

        function checkMostpurchasedItemsAvailable(productId, catalog) {
            if (
                angular.isDefined(productId) &&
                productId != null &&
                productId != ""
            ) {
                $scope.vendorIds = window.__env.InternalVendors;
                var Vendorexists = $scope.vendorIds.some(function (vendor) {
                    return vendor.toLowerCase() === catalog.toLowerCase();
                });
                if (Vendorexists) {
                    elasticService
                        .getOrdersLineItemElasticData(
                            elasticService.buildOrderIdsQuery(
                                productId.toUpperCase()
                            )
                        )
                        .then(function (responseData) {
                            if (
                                responseData &&
                                responseData.data &&
                                responseData.data.aggregations &&
                                responseData.data.aggregations
                                    .distinct_orderIds &&
                                responseData.data.aggregations.distinct_orderIds
                                    .buckets &&
                                responseData.data.aggregations.distinct_orderIds
                                    .buckets.length > 0
                            ) {
                                $scope.orderHits =
                                    responseData.data.aggregations.distinct_orderIds.buckets;
                                $scope.orderIds = $scope.orderHits.map(
                                    function (orderIds) {
                                        return orderIds.key;
                                    }
                                );

                                if ($scope.orderIds.length > 0) {
                                    elasticService
                                        .getOrdersLineItemElasticData(
                                            elasticService.buildRelatedProductsQuery(
                                                $scope.orderIds,
                                                $scope.vendorIds,
                                                productId.toUpperCase()
                                            )
                                        )
                                        .then(function (responseData) {
                                            if (
                                                responseData &&
                                                responseData.data &&
                                                responseData.data
                                                    .aggregations &&
                                                responseData.data.aggregations
                                                    .frequently_bought_together &&
                                                responseData.data.aggregations
                                                    .frequently_bought_together
                                                    .buckets &&
                                                responseData.data.aggregations
                                                    .frequently_bought_together
                                                    .buckets.length > 0
                                            ) {
                                                var buckets =
                                                    responseData.data
                                                        .aggregations
                                                        .frequently_bought_together
                                                        .buckets;
                                                $scope.frequently_bought_together_Products =
                                                    buckets.map(function (
                                                        bucket
                                                    ) {
                                                        return bucket.key;
                                                    });
                                                $scope.frequently_bought_together_Products.push(
                                                    productId
                                                );
                                                if (
                                                    $scope
                                                        .frequently_bought_together_Products
                                                        .length == 3
                                                ) {
                                                    $scope.seriesId =
                                                        $scope.generateGuid();
                                                    elasticService
                                                        .getElasticData(
                                                            elasticService.buildProductInfoRequest(
                                                                $scope.frequently_bought_together_Products,
                                                                undefined,
                                                                undefined,
                                                                true
                                                            )
                                                        )
                                                        .then(function (
                                                            responseData
                                                        ) {
                                                            if (
                                                                responseData &&
                                                                responseData.data &&
                                                                responseData
                                                                    .data
                                                                    .hits &&
                                                                responseData
                                                                    .data.hits
                                                                    .hits
                                                                    .length > 0
                                                            ) {
                                                                $scope.hasMostPurchasedProduct = true;
                                                                $scope.isBoughttogetherSaleActive = true;
                                                                $scope.productData =
                                                                    responseData.data.hits.hits;

                                                                for (
                                                                    var i = 0;
                                                                    i <
                                                                    $scope
                                                                        .productData
                                                                        .length;
                                                                    i++
                                                                ) {
                                                                    var product =
                                                                        $scope
                                                                            .productData[
                                                                            i
                                                                        ]
                                                                            ._source;
                                                                    var salePrice =
                                                                        !isNaN(
                                                                            product.salePrice
                                                                        )
                                                                            ? parseFloat(
                                                                                  product.salePrice
                                                                              )
                                                                            : 0; // Convert to number or set to 0 if NaN
                                                                    var discountRate =
                                                                        parseFloat(
                                                                            window
                                                                                .__env
                                                                                .FrequentlyBoughtTogetherDiscountRate
                                                                        ); // Convert to number or set to 1 if NaN (to avoid division by zero)
                                                                    var calculatedSalePrice =
                                                                        salePrice !==
                                                                        0
                                                                            ? salePrice -
                                                                              salePrice /
                                                                                  discountRate
                                                                            : product.listPrice -
                                                                              product.listPrice /
                                                                                  discountRate;
                                                                    var clubPrice =
                                                                        !isNaN(
                                                                            product.clubPrice
                                                                        )
                                                                            ? parseFloat(
                                                                                  product.clubPrice
                                                                              )
                                                                            : salePrice;
                                                                    var calculatedClubprice =
                                                                        clubPrice !==
                                                                        0
                                                                            ? clubPrice -
                                                                              clubPrice /
                                                                                  discountRate
                                                                            : calculatedSalePrice;

                                                                    $scope.discountPercentage =
                                                                        discountRate
                                                                            ? Math.round(
                                                                                  (1 /
                                                                                      discountRate) *
                                                                                      100
                                                                              )
                                                                            : 0;

                                                                    // Create a summary object with required fields
                                                                    if (
                                                                        calculatedClubprice >
                                                                        calculatedSalePrice
                                                                    ) {
                                                                        calculatedClubprice =
                                                                            calculatedSalePrice;
                                                                    }
                                                                    $scope.totallistPrice +=
                                                                        salePrice !==
                                                                        0
                                                                            ? salePrice
                                                                            : product.listPrice;
                                                                    $scope.totalsalePrice +=
                                                                        calculatedSalePrice;
                                                                    $scope.totalclubPrice +=
                                                                        calculatedClubprice;
                                                                    var productDetails =
                                                                        {
                                                                            name: product.name,
                                                                            listPrice:
                                                                                salePrice !==
                                                                                0
                                                                                    ? salePrice
                                                                                    : product.listPrice,
                                                                            variants:
                                                                                product
                                                                                    .variants
                                                                                    .length,
                                                                            definitionName:
                                                                                product.definitionName,
                                                                            catalog:
                                                                                product.catalog,
                                                                            itemId: product.itemId,
                                                                            rating: product.rating,
                                                                            runTime:
                                                                                product.runTime,
                                                                            selected: true,
                                                                        };

                                                                    // Push this object into the summary array
                                                                    $scope.productSummary.push(
                                                                        productDetails
                                                                    );
                                                                }
                                                            }
                                                        });
                                                } else {
                                                    $scope.hasMostPurchasedProduct = false;
                                                    $scope.isBoughttogetherSaleActive = false;
                                                }
                                            }
                                        });
                                }
                            }
                        });
                } else {
                    $scope.hasMostPurchasedProduct = false;
                    $scope.isBoughttogetherSaleActive = false;
                }
            }
        }

        $scope.onVariantOptionChange = function (key, variantOption) {
            loaderService.show();
            var expectedVariantKeyParts = [];
            angular.forEach(
                $scope.variantOptionsAvailable,
                function (scopeVariants) {
                    if (scopeVariants.variantOptions == key) {
                        $scope.selectedVariant[key] = variantOption;

                        expectedVariantKeyParts.push(key + "-" + variantOption);
                    } else {
                        var optionkey =
                            $scope.selectedVariant[
                                scopeVariants.variantOptions
                            ];
                        expectedVariantKeyParts.push(
                            scopeVariants.variantOptions + "-" + optionkey
                        );
                    }
                }
            );
            expectedVariantKeyParts.sort();
            var selectedVariantKey = expectedVariantKeyParts.join("|");

            var selectedVariant = _.find(
                $scope.variantMaps,
                function (variant) {
                    return variant.VariantKey == selectedVariantKey;
                }
            );
            if (selectedVariant) {
                $scope.selectedVariantId = selectedVariant.VariantId;
            }

            $window.location.replace(
                "/" +
                    urlService.getProductUrl({
                        definitionName: $scope.prdDefinition,
                        catalogId: $scope.productInfo._source.catalog,
                        name: $scope.productInfo._source.name,
                        sku: $scope.prdId + "_var_" + $scope.selectedVariantId,
                    })
            );
            loaderService.hide();
        };

        $scope.initializeVariantMapping = function (currentVariantId) {
            $scope.selectedVariantId = currentVariantId;
            if (angular.isDefined($window.variantMaps)) {
                $scope.variantOptionsAvailable =
                    $window.variantOptionsAvailable;
            }
            if (angular.isDefined($window.variantMaps)) {
                $scope.variantMaps = $window.variantMaps;
                var selectedVariant = _.find(
                    $scope.variantMaps,
                    function (variant) {
                        return variant.VariantId == $scope.selectedVariantId;
                    }
                );
                if (selectedVariant) {
                    var parts = selectedVariant.VariantKey.split("|");
                    angular.forEach(parts, function (part) {
                        var variants = part.split("-");
                        $scope.availableVariantOptions.push(variants[0]);
                        $scope.selectedVariant[variants[0]] = variants[1];
                    });
                    $scope.showMultipleVariantsDropdowns = true;
                }
            }
        };

        $scope.toggleDropdown = function (variantKey) {
            for (var key in $scope.isDropdownOpen) {
                if (key != variantKey) {
                    $scope.isDropdownOpen[key] = false;
                }
            }
            $scope.isDropdownOpen[variantKey] =
                !$scope.isDropdownOpen[variantKey];
        };

        $scope.selectVariant = function (value, variantKey) {
            loaderService.show();
            $scope.selectedVariant[variantKey] = value;
            $scope.isDropdownOpen[variantKey] = false;
            $scope.onVariantOptionChange(variantKey, value);
        };

        $document.on("click", function (event) {
            var dropdownElement = document.querySelector(
                ".variant-options-container"
            );
            if (dropdownElement && !dropdownElement.contains(event.target)) {
                $scope.$apply(function () {
                    $scope.isDropdownOpen = {};
                });
            }
        });

        // Clean up the event listener when the scope is destroyed
        $scope.$on("$destroy", function () {
            $document.off("click");
        });

        //-----region  Membership Modal plan checkou
        $scope.getMembershipPlans = function () {
            membershipService.getMembershipPlans().then(function (response) {
                if (response && response.data) {
                    $rootscope.membershipPlans = response.data;
                    $scope.selectedPlan =
                        response.data[0].planTenure.toString();
                }
            });
        };

        $scope.selectPlan = function (planTenure) {
            $scope.selectedPlan = planTenure.toString(); // Set the selected plan value
        };

        $scope.onMembershipModalInit = function () {
            if (
                $rootscope.isMembershipInfoAvailable == false ||
                angular.isUndefined($rootscope.isMembershipInfoAvailable)
            ) {
                $scope.getMembershipPlans();
                $rootscope.isMembershipInfoAvailable = true;
            }
        };

        $scope.onMembershipCheckout = function () {
            $rootscope.showLoader = true;
            if ($scope.selectedPlan) {
                var planToCheckout = $rootscope.membershipPlans.filter(
                    function (plan) {
                        return plan.planTenure == $scope.selectedPlan;
                    }
                );
                if (angular.isDefined(planToCheckout)) {
                    $rootscope.showLoader = true;
                    $scope.toggleModal("mdlCircle", false);
                    cartService
                        .addMembershipCart(
                            planToCheckout[0].planId,
                            planToCheckout[0].planTenure
                        )
                        .then(function (response) {
                            if (response && response.data) {
                                $rootscope.showLoader = false;
                                $window.location.href = "/cart/checkout";
                            } else {
                                $rootscope.showLoader = false;
                                $window.location.href =
                                    "/account/login?ReturnUrl=/embroidery-circle";
                            }
                        });
                } else {
                    alert("Please select a valid Plan");
                }
            } else {
                alert("Please select a valid Plan");
            }
        };
        //-----endregion
        function checkItemInFavorites(itemId) {
            favoritesService.checkItemInFavorites(itemId)
                .then(function(response) {
                    $rootscope.isProductInFavorites = response.data;
                })
                .catch(function(error) {
                    console.log('Error checking favorites:', error);
                    $rootscope.isProductInFavorites = false;
                });
        }
    },
]);
